module.exports = __webpack_public_path__ + "img/business_proposal_booker.12305585.png";